<!--
This components is sensitive to API response order. It expects to be ordered 
by travel_season_id in order to see correctly the rowspan=2
-->
<template>
  <fragment>
    <template v-for="(row, index) in rows">
      <md-table-row :key="index">
        <md-table-cell
          v-if="
            !index ||
              rows[index - 1].travel_season_id != rows[index].travel_season_id
          "
          v-bind:rowspan="2"
          >{{ row.travel_season }}</md-table-cell
        ><!-- 2 is hardcoded since there is only two possible values -->
        <md-table-cell>{{
          row.demand_type == "HIGH_DEMAND" ? "HD" : "LD"
        }}</md-table-cell>

        <!-- target-table-tuple is bind to API tuple -->
        <slot v-bind:row="row"></slot>
      </md-table-row>
    </template>
  </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

export default {
  name: "TargetTableDataPerSeasonAndDemand",
  props: {
    rows: Array,
    filters: Object
  },
  components: {
    Fragment
  }
};
</script>
